import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Users, Star, Globe, Clock, Shield, Award } from 'lucide-react';

const stats = [
  { icon: Users, value: '10,000+', label: 'Happy Clients', suffix: '' },
  { icon: Star, value: '4.9', label: 'Average Rating', suffix: '/5' },
  { icon: Globe, value: '25+', label: 'Countries Served', suffix: '' },
  { icon: Clock, value: '15+', label: 'Years Experience', suffix: '' },
];

const trustBadges = [
  { icon: Shield, text: 'Verified Astrologer' },
  { icon: Award, text: 'Certified Vastu Expert' },
  { icon: Star, text: 'Gold Medalist' },
];

const TrustIndicators = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      className="relative py-20"
      data-testid="trust-indicators-section"
      ref={ref}
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#1E293B]/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="stat-item glass rounded-2xl"
                data-testid={`stat-${index}`}
              >
                <Icon className="text-[#D4AF37] mx-auto mb-4" size={32} />
                <div className="stat-number">
                  {stat.value}
                  <span className="text-2xl">{stat.suffix}</span>
                </div>
                <p className="stat-label">{stat.label}</p>
              </motion.div>
            );
          })}
        </div>

        {/* Trust Badges */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="flex flex-wrap justify-center gap-4 mt-12"
        >
          {trustBadges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div
                key={badge.text}
                className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#D4AF37]/30 bg-[#D4AF37]/5"
                data-testid={`trust-badge-${index}`}
              >
                <Icon className="text-[#D4AF37]" size={18} />
                <span className="text-[#F8FAFC] text-sm font-medium">{badge.text}</span>
              </div>
            );
          })}
        </motion.div>

        {/* Tagline */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5, delay: 0.7 }}
          className="text-center text-[#94A3B8] mt-10 text-lg"
        >
          Trusted by clients from <span className="text-[#D4AF37]">India, USA, UK, Canada, UAE</span> and more
        </motion.p>
      </div>
    </section>
  );
};

export default TrustIndicators;
